module.exports = __webpack_public_path__ + "assets/images/ote_sport_8.0b78640ce38b354542aef83a8feb9a46.png";